export class Period {
  startedOn: string;      // "dd-MM-yyyy"
  endedOn?: string | null;
  id?: string | null;

  constructor(startedOn: string, endedOn?: string | null) {
    this.startedOn = startedOn;
    this.endedOn = endedOn ?? null;
  }
}

export type CycleStatus = "past" | "current" | 'predicted';

export class Cycle {
  startedOn: string;      // "dd-MM-yyyy"
  endedOn?: string | null;
  type: CycleStatus

  constructor(startedOn: string, type: CycleStatus, endedOn?: string | null) {
    this.startedOn = startedOn;
    this.endedOn = endedOn ?? null;
    this.type = type;
  }
}

export interface Pregnancy {
  id: string;
  startDate: string;
  endDate?: string;
  dueDate: string;
}